export const mapContactToForm = ({ contactData, reset, setPhotoImage, setFingerprintImage, setSignatureImage }) => {
  const formattedContact = {
    firstName: contactData?.firstName,
    lastName: contactData?.lastName,
    gender: contactData?.gender,
    dateOfBirth: contactData?.birthDate || '',
    licenseNumber: contactData?.licenseNumber,
    licenseState: contactData?.state,
    licenseType: contactData?.idType,
    address1: contactData?.address1,
    address2: contactData?.address2,
    phoneNumber: contactData?.phone1,
    city: contactData?.city,
    state: contactData?.state,
    zip: contactData?.zip,
  }
  reset(formattedContact)
  setPhotoImage({
    filename: contactData?.image,
    isTemp: false,
  })
  setFingerprintImage({
    filename: contactData?.thumbprintImage,
    isTemp: false,
  })
  setSignatureImage({
    filename: contactData?.signatureImage,
    isTemp: false,
  })
}

export const formatFormData = (data, currentContact, photoImage, fingerprintImage, signatureImage) => {
  const isDev = process.env.REACT_APP_STAGE === 'dev'

  return {
    ...currentContact,
    firstName: data.firstName,
    firstNameLegal: data.firstName,
    lastName: data.lastName,
    lastNameLegal: data.lastName,
    gender: data.gender,
    birthDate: Number(data.dateOfBirth) || Number(new Date(data.dateOfBirth)),
    licenseNumber: data.licenseNumber,
    licenseState: data.licenseState,
    idType: data.licenseType,
    address1: data.address1,
    address2: data.address2,
    phone1: data.phoneNumber,
    city: data.city,
    state: data.state,
    zip: data.zip,
    image: photoImage?.filename,
    thumbprintImage: fingerprintImage?.filename || (isDev ? photoImage?.filename : ''),
    signatureImage: signatureImage?.filename || (isDev ? photoImage?.filename : ''),
  }
}
